import React from 'react';
import { Box, Divider, Grid, Typography, Link } from '@mui/material';

const Footer = () => {
    return (
        <footer className="s-footer" style={{ position: 'relative', backgroundColor: '#212121' }}>
            <Box sx={{ py: 4, px: 5 }}>
                <Grid container spacing={3}>
                    {/* Column 1: Introduction */}
                    <Grid item lg={4} md={6} xs={12}>
                        <Typography variant="h6" fontWeight="bold" sx={{ mb: 3, color: 'white' }}>
                            Divine Conquer 2025
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'white', lineHeight: 1.6 }}>
                            Pure Classic conquer with modern client, Anti-Cheat, and high FPS with stable ping.
                            Experience the old memories of classic conquer. Divine Conquer is a private classic server!
                        </Typography>
                    </Grid>

                    {/* Column 2: Empty or future content */}
                    <Grid item lg={4} md={6} xs={12} />

                    {/* Column 3: Disclaimer and Links */}
                    <Grid item lg={4} md={6} xs={12}>
                        <Typography variant="h6" fontWeight="bold" sx={{ mb: 3, color: 'white' }}>
                            Disclaimer
                        </Typography>
                        <Typography variant="body2" sx={{ color: 'white', mb: 2 }}>
                            Divine Conquer is NOT related to TQ Digital or any official server.
                        </Typography>

                        {/* Links Section */}
                        <Typography variant="h6" sx={{ mb: 2, color: 'white' }}>
                            Links
                        </Typography>
                        <ul className="list-inline social-1" style={{ paddingLeft: 0 }}>
                            <li style={{ display: 'inline', marginRight: '10px' }}>
                                <Link
                                    href="https://discord.gg/eRp2NZy9be"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    sx={{
                                        color: 'white',
                                        textDecoration: 'none',
                                        '&:hover': {
                                            color: '#7289da', // Discord blue
                                        },
                                    }}
                                >
                                    Discord
                                </Link>
                            </li>
                            <li style={{ display: 'inline', marginRight: '10px' }}>
                                <Link
                                    href="https://www.facebook.com/profile.php?id=61574257703392"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    sx={{
                                        color: 'white',
                                        textDecoration: 'none',
                                        '&:hover': {
                                            color: '#1877f2', // Facebook blue
                                        },
                                    }}
                                >
                                    Facebook
                                </Link>
                            </li>
                            <li style={{ display: 'inline', marginRight: '10px' }}>
                                <Link
                                    href="https://www.xtremetop100.com/in.php?site=1132377142"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    sx={{
                                        color: 'white',
                                        textDecoration: 'none',
                                        '&:hover': {
                                            color: '#ffac33', // XtremeTop100 hover color
                                        },
                                    }}
                                >
                                    <img
                                        src="https://www.xtremeTop100.com/votenew.jpg"
                                        alt="Conquer Online Top 100"
                                        style={{ border: 0, height: '30px' }}
                                    />
                                </Link>
                            </li>
                        </ul>
                    </Grid>
                </Grid>
            </Box>

            <Divider sx={{ my: 3, borderColor: 'gray' }} />
            <Box sx={{ textAlign: 'center', py: 2 }}>
                <Typography variant="body2" color="white">
                    � 2025 Divine Conquer. All Rights Reserved.
                </Typography>
            </Box>
        </footer>
    );
};

export default Footer;
